/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EvaluationState } from './EvaluationState';
import {
    instanceOfEvaluationState,
    EvaluationStateFromJSON,
    EvaluationStateFromJSONTyped,
    EvaluationStateToJSON,
} from './EvaluationState';

/**
 * @type BeamAnalysisWorkResultDtoOutput
 * 
 * @export
 */
export type BeamAnalysisWorkResultDtoOutput = EvaluationState;


export function BeamAnalysisWorkResultDtoOutputFromJSON(json: any): BeamAnalysisWorkResultDtoOutput {
    return BeamAnalysisWorkResultDtoOutputFromJSONTyped(json, false);
}

export function BeamAnalysisWorkResultDtoOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisWorkResultDtoOutput {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EvaluationStateFromJSONTyped(json, true) };
    return  EvaluationStateFromJSONTyped(json, true);
}

export function BeamAnalysisWorkResultDtoOutputToJSON(value?: BeamAnalysisWorkResultDtoOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEvaluationState(value)) {
        return EvaluationStateToJSON(value as EvaluationState);
    }

    return {};
}

/**
 * Check if a given object implements the BeamAnalysisWorkResultDtoOutput interface.
 */
export function instanceOfBeamAnalysisWorkResultDtoOutput(value: any): value is BeamAnalysisWorkResultDtoOutput {
    if (instanceOfEvaluationState(value)) return true;
    return false;
}

